/*eslint-disable*/
import React from 'react';
import { Card, CardHeader, CardBody, Row, Col, CardTitle } from 'reactstrap';
import DataGrid, { MasterDetail, Column, Paging, Format, Export, Editing, Lookup, Popup, FilterRow, HeaderFilter } from 'devextreme-react/data-grid';
import { config } from '../../../utils/config';
import { callApi, callKrakenApi } from '../../../utils/utils';
import { Workbook } from 'exceljs';
import { exportDataGrid } from 'devextreme/excel_exporter';

export default class Template_UbiCalAceLote extends React.Component {
    constructor(props) {
        super(props);

        const rowFamilia = {
            ClaUbicacion: null,
            claProducto: null,
        }
        this.state = {            
            isProductosVisible: false,
            rowFamilia
        }

        this.dataGrid = null;

        this.handleOptionChange = this.handleOptionChange.bind(this);   
        this.validateRemove = this.validateRemove.bind(this);
    }




    handleOptionChange(e) {
        if (e.fullName === 'paging.pageIndex') {
          this.props.onPage(e.value);
        }
    }

    validateRemove(e){
        this.props.onDeleting(e);
    }
    
    onExporting(e) {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Main sheet');
        exportDataGrid({
            component: e.component,
            worksheet: worksheet,
            customizeCell: function(options) {
                const excelCell = options;
                excelCell.font = { name: 'Arial', size: 12 };
                excelCell.alignment = { horizontal: 'left' };
            } 
        }).then(function() {
            workbook.xlsx.writeBuffer()
                .then(function(buffer) {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Configuración.xlsx');
                });
        });
        e.cancel = true;
    }

    componentDidMount(){
    }

    componentDidUpdate(){
    }

    render(){
        const gridContent = (
            <DataGrid
                id="gridConfiguracion"
                ref={(ref) => this.dataGrid = ref}
                dataSource={this.props.data}
                key={'IdCfgConfiguracionGeneral'}
                width="100%"
                height={600}
                selection={{ mode: 'single' }}
                showBorders={false}
                columnHidingEnabled
                columnAutoWidth={true}
                showColumnHeaders
                showColumnLines={false}
                showRowLines
                noDataText="Sin Registros"
                wordWrapEnabled
                rowAlternationEnabled={false}
                onOptionChanged={this.handleOptionChange}
                remoteOperations={true}
                repaintChangesOnly={true}  
                onRowRemoving={this.validateRemove}      
                onExporting={this.onExporting}   
            >
                <FilterRow
                    visible={true}
                    applyFilter={true}
                />
                <HeaderFilter visible={true}  width={"400"}/> 

                <Editing                
                    mode="popup"
                    allowAdding={false}
                    allowDeleting={true}
                    allowUpdating={false}
                />

                <Column dataField="IdCfgConfiguracionGeneral" caption="IdCfgConfiguracionGeneral" width={100} visible={false}/>
                <Column dataField="IdConfiguracion" caption="IdConfiguracion" width={150} visible={false}/>
                <Column
                    dataField="NomUbicacion" 
                    caption="Ubicacion" 
                    width={100} 
                >
                </Column>
                <Column 
                    dataField="NombreCalibre" 
                    caption="Calibre" 
                    width={70}
                >
                </Column>
                <Column dataField="LoteMinimo" caption="Lote Mínimo" width={70} visible={true} alignment={"left"} format={"000,000"}/>

                <Paging
                    pageSize={30}
                    pageIndex={this.props.pageIndex}
                />
                
                <Export enabled={true} allowExportSelectedData={false} />
                
            </DataGrid>
        );

        return(
            <div className="content mb-5">
                {gridContent}
            </div>
        )
    };
}